import { render, staticRenderFns } from "./ContactsSetSuccessDialog.vue?vue&type=template&id=b836304c"
import script from "./ContactsSetSuccessDialog.vue?vue&type=script&lang=js"
export * from "./ContactsSetSuccessDialog.vue?vue&type=script&lang=js"
import style0 from "./ContactsSetSuccessDialog.vue?vue&type=style&index=0&id=b836304c&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports